module.exports = __webpack_public_path__ + "img/mimg05.09ad0d6f.jpg";